var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgParks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 11.4084C16.2765 11.9871 18.3333 13.3087 18.3333 14.8464C18.3333 16.9175 14.6023 18.5964 9.99996 18.5964C5.39759 18.5964 1.66663 16.9175 1.66663 14.8464C1.66663 13.3087 3.72345 11.9871 6.66663 11.4084M9.99996 14.4297V7.76306M9.99996 7.76306C11.3807 7.76306 12.5 6.64377 12.5 5.26306C12.5 3.88235 11.3807 2.76306 9.99996 2.76306C8.61925 2.76306 7.49996 3.88235 7.49996 5.26306C7.49996 6.64377 8.61925 7.76306 9.99996 7.76306Z",
    stroke: "#667185",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParks);
export default __webpack_public_path__ + "static/media/parks.3b486cd651dff1a681a8fd0e5e933697.svg";
export { ForwardRef as ReactComponent };